export { type ThankYouProps, default as ThankYou } from './ThankYou';
